export default __webpack_public_path__ + "static/tatva-c247bc2171aaf473abc057447523812f.png";